import { render, staticRenderFns } from "./ManageSub.vue?vue&type=template&id=383f9abc"
import script from "./ManageSub.vue?vue&type=script&lang=js"
export * from "./ManageSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports